import Grow from '@material-ui/core/Grow';
import React, { useCallback, useEffect } from 'react';
import { useCallbackObservable, useObservable } from 'react-use-observable';
import { hintFactory } from 'v2/services/hint';

import type { EHintPath } from 'v2/interfaces/hint';

import { useStyle } from './styles';

interface IProps {
  inputName: string;
  children: React.ReactNode;
}

export const useHint = (path: EHintPath) => {
  useEffect(() => {
    hintFactory.loadHint(path);
  }, [path]);
};

export const Hint = ({ children, inputName }: IProps) => {
  const classes = useStyle();

  useEffect(() => {
    hintFactory.setHint(inputName);

    return () => hintFactory.removeHint(inputName);
  }, [inputName]);

  const [hasHint] = useObservable(() => hintFactory.hasHint(inputName), [inputName]);
  const [hint] = useObservable(() => hintFactory.getHint(inputName), [inputName]);
  const [onMouseEnter] = useCallbackObservable((inpName) => hintFactory.onMouseEnter(inpName), []);
  const [onMouseLeave] = useCallbackObservable(() => hintFactory.onMouseLeave(), []);

  const handleMouseEnter = useCallback(() => onMouseEnter(inputName), [inputName, onMouseEnter]);

  if (!hint) {
    return <>{children}</>;
  }

  return (
    <div onMouseEnter={handleMouseEnter} onMouseLeave={onMouseLeave}>
      <Grow in={hasHint}>
        <div id='hint' className={classes.popOver}>
          <div className={classes.popOver_title}>{hint.label}</div>
          <div>{hint.hint}</div>

          {!!hint.link && !!hint.link_description && (
            <div className={classes.linkContainer}>
              <a href={hint.link} className={classes.link} rel='noopener noreferrer' target='_blank'>
                {hint.link_description}
              </a>
            </div>
          )}
        </div>
      </Grow>
      {children}
    </div>
  );
};

export default Hint;
